module.exports = __webpack_public_path__ + "static/link-563c34730d532a3450ebe928e00c84cb.png";